export const languageConstants = {
    LANGUAGE_REQUEST: 'LANGUAGE__REQUEST',
    LANGUAGE_SUCCESS: 'LANGUAGE__SUCCESS',
    LANGUAGE_FAILURE: 'LANGUAGE__FAILURE',


    SET_SLUG: 'SET_SLUG'
};